import { ApiResponse, request } from './base';
import * as models from '../../models'; 

export const addInsuredPerson = async (claimId: any, insuredPerson: models.InsuredPerson) => {
    return await request({
        method: 'POST',
        url: `/claims/${claimId}/insuredPersons`,
        data: insuredPerson,
    });
}; 

export const patchInsuredPerson =async (id: any, patch: object) => {    
    return await request({
        method: 'PATCH',
        url: `/insuredPersons/${id}`,
        headers: {
            'Content-Type': 'application/json-patch+json'
        }, 
        data: patch,
    }); 
}; 

export const getInsuredPerson = async (id: any) => {    
    const response = await request({
        method: 'GET',
        url: `/insuredPersons/${id}`, 
    });
    return response; 
}; 